(function () {
  'use strict';

  function initBannerCalc(root) {
    var mode = 'distance';
    var slider = root.querySelector('[data-main-slider]');
    var label = root.querySelector('[data-input-label]');
    var readout = root.querySelector('[data-input-readout]');
    var btnDistance = root.querySelector('[data-mode-btn="distance"]');
    var btnLetter = root.querySelector('[data-mode-btn="letter"]');
    var tickGroup = root.querySelector('[data-tick-group]');
    var markerGroup = root.querySelector('[data-marker-group]');

    var outMin = root.querySelector('[data-out-min]');
    var outMinPt = root.querySelector('[data-out-min-pt]');
    var outBest = root.querySelector('[data-out-best]');
    var outBestPt = root.querySelector('[data-out-best-pt]');
    var outBanner = root.querySelector('[data-out-banner]');
    var outUsecase = root.querySelector('[data-out-usecase]');

    var svgNS = 'http://www.w3.org/2000/svg';

    function setActiveToggle(distanceMode) {
      if (distanceMode) {
        btnDistance.classList.add('is-active');
        btnDistance.setAttribute('aria-selected', 'true');
        btnLetter.classList.remove('is-active');
        btnLetter.setAttribute('aria-selected', 'false');
      } else {
        btnLetter.classList.add('is-active');
        btnLetter.setAttribute('aria-selected', 'true');
        btnDistance.classList.remove('is-active');
        btnDistance.setAttribute('aria-selected', 'false');
      }
    }

    function setMode(m) {
      mode = m;
      if (m === 'distance') {
        setActiveToggle(true);
        label.textContent = 'Viewing distance';
        slider.min = 5;
        slider.max = 300;
        slider.step = 1;
        slider.value = 30;
      } else {
        setActiveToggle(false);
        label.textContent = 'Letter height';
        slider.min = 1;
        slider.max = 36;
        slider.step = 0.5;
        slider.value = 3;
      }
      update();
    }

    function useCase(widthFt) {
      if (widthFt <= 3) return 'Storefront window, booth table sign';
      if (widthFt <= 6) return 'Storefront, trade show booth';
      if (widthFt <= 10) return 'Building facade, fence line';
      if (widthFt <= 20) return 'Grand opening, roadside frontage';
      return 'Highway, stadium, large facade';
    }

    function bannerWidthLabel(distanceFt) {
      if (distanceFt <= 15) return '3 ft';
      if (distanceFt <= 30) return '3\u20136 ft';
      if (distanceFt <= 60) return '6\u201310 ft';
      if (distanceFt <= 120) return '10\u201320 ft';
      return '20+ ft';
    }

    function bannerWidthNumeric(label) {
      var match = label.match(/\d+/);
      return match ? parseInt(match[0], 10) : 3;
    }

    function clearGroup(g) {
      while (g.firstChild) g.removeChild(g.firstChild);
    }

    function drawTape(distanceFt, bestIn) {
      var svgMax = mode === 'distance' ? 300 : 40;
      var svgVal = mode === 'distance' ? distanceFt : bestIn;

      clearGroup(tickGroup);
      clearGroup(markerGroup);

      var steps = mode === 'distance' ? 10 : 8;
      for (var i = 0; i <= steps; i++) {
        var x = 10 + (i / steps) * 620;
        var h = i % 2 === 0 ? 12 : 7;

        var tick = document.createElementNS(svgNS, 'line');
        tick.setAttribute('x1', x);
        tick.setAttribute('x2', x);
        tick.setAttribute('y1', 38);
        tick.setAttribute('y2', 38 - h);
        tick.setAttribute('stroke-width', '1.5');
        tick.setAttribute('data-tick', '1');
        tickGroup.appendChild(tick);

        if (i % 2 === 0) {
          var txt = document.createElementNS(svgNS, 'text');
          txt.setAttribute('x', x);
          txt.setAttribute('y', 30);
          txt.setAttribute('font-size', '9');
          txt.setAttribute('text-anchor', 'middle');
          txt.textContent = Math.round((i / steps) * svgMax);
          tickGroup.appendChild(txt);
        }
      }

      var pos = 10 + Math.min(svgVal / svgMax, 1) * 620;

      var line = document.createElementNS(svgNS, 'line');
      line.setAttribute('x1', pos);
      line.setAttribute('x2', pos);
      line.setAttribute('y1', 60);
      line.setAttribute('y2', 80);
      line.setAttribute('stroke', 'rgb(var(--color-button))');
      line.setAttribute('stroke-width', '2');
      markerGroup.appendChild(line);

      var circle = document.createElementNS(svgNS, 'circle');
      circle.setAttribute('cx', pos);
      circle.setAttribute('cy', 45);
      circle.setAttribute('r', 9);
      circle.setAttribute('fill', 'rgb(var(--color-button))');
      markerGroup.appendChild(circle);
    }

    function update() {
      var val = parseFloat(slider.value);
      var distanceFt, minIn, bestIn;

      if (mode === 'distance') {
        distanceFt = val;
        minIn = distanceFt / 40;
        bestIn = distanceFt / 10;
        readout.textContent = Math.round(distanceFt) + ' ft';
      } else {
        bestIn = val;
        distanceFt = bestIn * 10;
        minIn = distanceFt / 40;
        readout.textContent = val.toFixed(1) + ' in';
      }

      var widthLabel = bannerWidthLabel(distanceFt);

      outMin.textContent = minIn.toFixed(2) + ' in';
      outMinPt.textContent = Math.round(minIn * 72) + ' pt \u00b7 readable to ' + Math.round(distanceFt) + ' ft';
      outBest.textContent = bestIn.toFixed(2) + ' in';
      outBestPt.textContent = Math.round(bestIn * 72) + ' pt \u00b7 best impact at ' + Math.round(distanceFt) + ' ft';
      outBanner.textContent = widthLabel;
      outUsecase.textContent = useCase(bannerWidthNumeric(widthLabel));

      drawTape(distanceFt, bestIn);
    }

    btnDistance.addEventListener('click', function () {
      setMode('distance');
    });
    btnLetter.addEventListener('click', function () {
      setMode('letter');
    });
    slider.addEventListener('input', update);

    update();
  }

  document.querySelectorAll('[data-banner-calc]').forEach(initBannerCalc);
})();
